export  const maxTwoDecimals =(val: any) => !! (val?.toString().match(/^(\d*\.{0,1}\d{0,2}$)/));
export  const containsDecimals =(val: any) => Math.floor(val) !== val;
